function rebuildCarouselFromInput(productCard, input, mediaLink) {
  try {
    if (!productCard || !input) return;
    const carouselWrapper = productCard.querySelector('.carousel');
    const carouselViewport = carouselWrapper ? carouselWrapper.querySelector('.carousel__viewport') : null;
    const srcsStr = input.getAttribute('data-carousel-srcs');
    const srcsetsStr = input.getAttribute('data-carousel-srcsets');
    if (carouselWrapper && carouselViewport && srcsStr && srcsetsStr) {
      const srcs = srcsStr.split('||');
      const srcsets = srcsetsStr.split('||');
      const images = srcs.map((src, idx) => ({ src: src, srcset: srcsets[idx] || '' }));
      if (!Array.isArray(images) || images.length === 0) return;

      const productId = input.getAttribute('data-product-id');
      const sectionId = input.getAttribute('data-section-id');
      const productUrl = input.getAttribute('data-product-url') || (mediaLink ? mediaLink.getAttribute('href') : '#');
      const primaryImgEl = productCard.querySelector('.product-card__image--primary');
      const imageClass = primaryImgEl ? primaryImgEl.getAttribute('class') : 'product-card__image product-card__image--primary';
      const sizesAttr = primaryImgEl ? primaryImgEl.getAttribute('sizes') : null;
      const altAttr = primaryImgEl ? primaryImgEl.getAttribute('alt') : '';
      
      // Preload the first image of the new carousel before swapping DOM to avoid flicker
      const preloadImg = new Image();
      if (sizesAttr) preloadImg.sizes = sizesAttr;
      if (images[0].srcset) preloadImg.srcset = images[0].srcset;
      preloadImg.src = images[0].src;

      const token = Date.now() + Math.random();
      productCard._robotRebuildToken = token;

      const doRebuild = () => {
        if (productCard._robotRebuildToken !== token) return; // superseded

        // Prevent layout jump: lock current heights during DOM swap
        const prevHeight = Math.max(carouselViewport.offsetHeight, carouselWrapper.offsetHeight);
        if (prevHeight > 0) {
          carouselViewport.style.height = prevHeight + 'px';
          carouselWrapper.style.height = prevHeight + 'px';
        }

        // Find the first existing slide to use as temp instead of creating new element
        const firstSlide = carouselViewport.querySelector('.carousel__slide');
        let tempSlide = null;
        
        if (firstSlide) {
          // Use existing first slide as temp
          tempSlide = firstSlide;
          tempSlide.classList.add('carousel__temp');
          
          // Update the temp slide's image to show the current swatch image
          const tempImg = tempSlide.querySelector('img');
          if (tempImg && primaryImgEl) {
            const currentSrc = primaryImgEl.getAttribute('src');
            const currentSrcset = primaryImgEl.getAttribute('srcset');
            if (currentSrc) tempImg.setAttribute('src', currentSrc);
            if (currentSrcset) tempImg.setAttribute('srcset', currentSrcset);
            
            // Ensure the temp slide image has exact same styling as primary image
            tempImg.style.width = '100%';
            tempImg.style.height = '100%';
            tempImg.style.objectFit = 'cover';
            tempImg.style.display = 'block';
          }
          
          // Get precise dimensions before applying absolute positioning
          const computedStyle = window.getComputedStyle(tempSlide);
          const slideWidth = tempSlide.offsetWidth;
          const slideHeight = tempSlide.offsetHeight;
          
          // Style the temp slide to overlay exactly
          tempSlide.style.position = 'absolute';
          tempSlide.style.top = '0';
          tempSlide.style.left = '0'; // Position at the start since we'll scroll to 0
          tempSlide.style.width = slideWidth + 'px';
          tempSlide.style.height = slideHeight + 'px';
          tempSlide.style.zIndex = '100';
          tempSlide.style.pointerEvents = 'none';
          // Preserve any important styles from the computed style
          tempSlide.style.flexShrink = computedStyle.flexShrink || '0';
          tempSlide.style.boxSizing = computedStyle.boxSizing || 'border-box';
        }

        // Build dots markup
        let dotsHtml = '<li class="carousel__dots-wrapper">\n  <ul class="carousel__dots">';
        for (let i = 1; i <= images.length; i++) {
          const slideId = `carousel__slide${productId}-${sectionId}-${i}`;
          dotsHtml += `\n    <li style="padding-inline-start: 0;">\n      <button class="carousel__dot" aria-label="Go to slide ${i}" data-slide-id="${slideId}"></button>\n    </li>`;
        }
        dotsHtml += '\n  </ul>\n</li>';

        // Build slides markup
        let slidesHtml = '';
        for (let i = 1; i <= images.length; i++) {
          const slideId = `carousel__slide${productId}-${sectionId}-${i}`;
          const prevId = `carousel__slide${productId}-${sectionId}-${i - 1}`;
          const nextId = `carousel__slide${productId}-${sectionId}-${i + 1}`;
          const img = images[i - 1];
          const prevDataIdx = i === 2 ? 'first' : '';
          const isSecondToLast = i === images.length - 1;
          const nextDataIdx = isSecondToLast ? 'last' : '';
          const slideIndexTag = i === 1 ? 'first' : (i === images.length ? 'last' : '');
          slidesHtml += `\n<li id="${slideId}" tabindex="0" class="carousel__slide"${slideIndexTag ? ` data-image-index="${slideIndexTag}"` : ''}>\n  <a href="${productUrl}" tabindex="0" aria-label="${altAttr ? altAttr.replace(/"/g, '&quot;') : ''}">\n    <img src="${img.src}" srcset="${img.srcset}"${sizesAttr ? ` sizes="${sizesAttr.replace(/"/g, '&quot;')}"` : ''} class="${imageClass}" alt="${altAttr ? altAttr.replace(/"/g, '&quot;') : ''}" loading="lazy">\n  </a>\n  <div class="carousel__snapper"></div>\n  <button class="carousel__control carousel__controls_prev" data-slide-id="${prevId}" data-image-index="${prevDataIdx}" aria-label="Previous image"></button>\n  <button class="carousel__control carousel__controls_next" data-slide-id="${nextId}" data-image-index="${nextDataIdx}" aria-label="Next image"></button>\n</li>`;
        }

        // Remove non-temp children, preserving the temp slide
        Array.from(carouselViewport.children).forEach((child) => {
          if (!child.classList.contains('carousel__temp')) {
            carouselViewport.removeChild(child);
          }
        });
        
        // Append dots and slides
        const _wrapper = document.createElement('div');
        _wrapper.innerHTML = `${dotsHtml}\n${slidesHtml}`;
        while (_wrapper.firstChild) {
          carouselViewport.appendChild(_wrapper.firstChild);
        }

        // Force immediate scroll reset to first position (disable smooth temporarily)
        const prevScrollBehavior = carouselViewport.style.scrollBehavior;
        carouselViewport.style.scrollBehavior = 'auto';
        carouselViewport.scrollLeft = 0;
        
        // Reset active dot
        const firstDot = carouselViewport.querySelector('.carousel__dot');
        if (firstDot) firstDot.classList.add('active');
        
        // Ensure temp slide stays aligned to the first position
        if (tempSlide) {
          tempSlide.style.left = '0px';
          tempSlide.style.transform = 'none';
        }
        
        // Additional scroll resets to ensure proper positioning
        requestAnimationFrame(() => {
          carouselViewport.scrollLeft = 0;
          // One more reset after temp slide removal
          requestAnimationFrame(() => {
            carouselViewport.scrollLeft = 0;
            // Restore prior scroll-behavior
            carouselViewport.style.scrollBehavior = prevScrollBehavior || '';
          });
        });

        // Reset wrapper classes
        carouselWrapper.classList.remove('hidden-next');
        if (!carouselWrapper.classList.contains('hidden-prev')) {
          carouselWrapper.classList.add('hidden-prev');
        }

        // Clear height locks after layout settles (two RAFs)
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            carouselViewport.style.height = '';
            carouselWrapper.style.height = '';
          });
        });

        // Remove temp slide immediately once new content is ready
        const firstSlideImgEl = carouselViewport.querySelector('.carousel__slide:not(.carousel__temp) img');
        if (firstSlideImgEl && tempSlide) {
          firstSlideImgEl.setAttribute('loading', 'eager');
          firstSlideImgEl.setAttribute('fetchpriority', 'high');
          
          const removeTemp = () => {
            if (tempSlide) {
              tempSlide.remove();
              // Ensure scroll position stays at 0 after temp removal
              carouselViewport.scrollLeft = 0;
            }
          };
          
          const waitUntilReadyThenRemove = () => {
            const rect = firstSlideImgEl.getBoundingClientRect();
            const painted = rect && rect.width > 0 && rect.height > 0 && firstSlideImgEl.complete && firstSlideImgEl.naturalWidth > 0;
            if (painted) {
              removeTemp();
            } else {
              requestAnimationFrame(waitUntilReadyThenRemove);
            }
          };
          
          if (firstSlideImgEl.complete && firstSlideImgEl.naturalWidth > 0) {
            // Already loaded, remove immediately
            removeTemp();
          } else if (typeof firstSlideImgEl.decode === 'function') {
            firstSlideImgEl.decode()
              .then(removeTemp)
              .catch(removeTemp);
          } else {
            firstSlideImgEl.addEventListener('load', removeTemp, { once: true });
            // Fallback timeout
            setTimeout(removeTemp, 1000);
          }
        } else if (tempSlide) {
          // No new image found, remove temp immediately
          tempSlide.remove();
          // Ensure scroll position stays at 0
          carouselViewport.scrollLeft = 0;
        }
      };

      if (typeof preloadImg.decode === 'function') {
        preloadImg.decode().then(doRebuild).catch(doRebuild);
      } else if (preloadImg.complete) {
        doRebuild();
      } else {
        preloadImg.onload = doRebuild;
        preloadImg.onerror = doRebuild;
      }
    }
  } catch (err) {
    console.error('[Robot Swatches] Failed to rebuild carousel', err);
  }
}


// Function to update quick add variants when swatch changes
function updateQuickAddVariants(productCard, swatchInput) {
  console.log('triggering quick add variants');
  try {
    // Find the quick add section
    const quickAddSection = productCard.querySelector('.product-card__quickadd');
    if (!quickAddSection) return;
    console.log('quickAddSection', quickAddSection);
    // Get the variant data JSON
    const variantDataScript = productCard.querySelector('.robot-variants-data');
    if (!variantDataScript) return;
    let variantData;
    try {
      variantData = JSON.parse(variantDataScript.textContent);
    } catch (e) {
      console.error('[Robot Swatches] Failed to parse variant data:', e);
      return;
    }
    // Get the product handle for the current swatch
    const productHandle = swatchInput.getAttribute('data-product-handle');

    if (!productHandle || !variantData[productHandle]) return;
    const productVariants = variantData[productHandle].variants;
    // Find the variant picker section
    const variantPickerValues = quickAddSection.querySelector('.variant-picker__option-values');
    if (!variantPickerValues) return;

    // Clear existing variants
    variantPickerValues.innerHTML = '';

    // Generate new variant buttons
    productVariants.forEach(variant => {
      const isDisabled = !variant.available;
      
      if (isDisabled) {
        // Create disabled variant with bell icon (for back in stock notifications)
        const disabledLink = document.createElement('a');
        disabledLink.href = variant.url + (variant.url.includes('?') ? '&' : '?') + 'bis-trigger';
        disabledLink.className = 'is-disabled block-swatch';
        disabledLink.setAttribute('data-variant-id', variant.id);
        disabledLink.innerHTML = `
          ${variant.title}
          <div class="disabled-bell">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 2a3 3 0 0 1 3 3v2.17l1.42 1.42A1 1 0 0 1 12.71 10H3.29a1 1 0 0 1-.71-1.71L4 6.86V5a3 3 0 0 1 3-3zM6 12h4a2 2 0 1 1-4 0z" fill="currentColor"/>
            </svg>
          </div>
        `;
        variantPickerValues.appendChild(disabledLink);
      } else {
        // Create available variant button
        const itemWrapper = document.createElement('div');
        itemWrapper.className = 'product-card__quickadd--item';
        
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'block-swatch';
        button.setAttribute('data-variant_id', variant.id);
        button.onclick = function(event) {
          if (typeof _addMeToCart === 'function') {
            _addMeToCart(event, this);
          }
        };
        button.textContent = variant.title;
        
        itemWrapper.appendChild(button);
        variantPickerValues.appendChild(itemWrapper);
      }
    });

  } catch (err) {
    console.error('[Robot Swatches] Failed to update quick add variants:', err);
  }
}

document.addEventListener('click', function(e) {
  if (!(e.target instanceof Element)) return;
  // Handle swatch click (label or input)
  const label = e.target.closest('label.ProductCard--ColorSwatch');
  if (!label) return;
  const input = label.querySelector('input.product-card-robot-swatch-input');
  if (!input) return;

  // Only handle if inside a swatch fieldset
  const fieldset = label.closest('.ProductCard--ColorSwatchesFieldset');
  if (!fieldset) return;
  const productCard = fieldset.closest('.product-card');
  if (!productCard) return;

  // Handle ProductCard--ColorSwatch--Active class management on click
  const swatchesWrapper = fieldset.closest('.ProductCard--ColorSwatchesFieldsetWrapper');
  if (swatchesWrapper) {
    // Remove active class from all ProductCard--ColorSwatch elements in this wrapper
    const allSwatches = swatchesWrapper.querySelectorAll('.ProductCard--ColorSwatch');
    allSwatches.forEach(swatch => swatch.classList.remove('ProductCard--ColorSwatch--Active'));
    // Add active class to the clicked swatch
    label.classList.add('ProductCard--ColorSwatch--Active');
  }

  // Find the main and secondary image elements
  const mainImage = productCard.querySelector('.product-card__image--primary');
  const secondaryImage = productCard.querySelector('.product-card__image--secondary');
  const mediaLink = productCard.querySelector('a.product-card__media');
  if (!mainImage) return;

  // Store original src/srcset/href if not already
  if (!fieldset._originalSrc) {
    fieldset._originalSrc = mainImage.getAttribute('src');
    fieldset._originalSrcset = mainImage.getAttribute('srcset');
    if (secondaryImage) {
      fieldset._originalSecondarySrc = secondaryImage.getAttribute('src');
      fieldset._originalSecondarySrcset = secondaryImage.getAttribute('srcset');
    }
    if (mediaLink) {
      fieldset._originalMediaHref = mediaLink.getAttribute('href');
    }
  }

  // If already checked, do nothing
  if (input.checked) return;

  // Uncheck all, check this one
  fieldset.querySelectorAll('.product-card-robot-swatch-input').forEach(function(i) {
    i.checked = false;
  });
  input.checked = true;

  // Update main image
  const newSrc = input.getAttribute('data-src');
  const newSrcset = input.getAttribute('data-srcset');
  if (newSrc) mainImage.setAttribute('src', newSrc);
  if (newSrcset) mainImage.setAttribute('srcset', newSrcset);

  // Update secondary image if present
  if (secondaryImage) {
    const newSecondarySrc = input.getAttribute('data-secondary-src');
    const newSecondarySrcset = input.getAttribute('data-secondary-srcset');
    if (newSecondarySrc) secondaryImage.setAttribute('src', newSecondarySrc);
    if (newSecondarySrcset) secondaryImage.setAttribute('srcset', newSecondarySrcset);
  }

  // Update product-card__media href
  if (mediaLink) {
    const newProductUrl = input.getAttribute('data-product-url');
    if (newProductUrl) mediaLink.setAttribute('href', newProductUrl);
  }

  // Update quick add variants for the selected product
  updateQuickAddVariants(productCard, input);

  // --- CAROUSEL REBUILD LOGIC ---
  try {
    const carouselWrapper = productCard.querySelector('.carousel');
    const carouselViewport = carouselWrapper ? carouselWrapper.querySelector('.carousel__viewport') : null;
    const srcsStr = input.getAttribute('data-carousel-srcs');
    const srcsetsStr = input.getAttribute('data-carousel-srcsets');
    if (carouselWrapper && carouselViewport && srcsStr && srcsetsStr) {
      const srcs = srcsStr.split('||');
      const srcsets = srcsetsStr.split('||');
      const images = srcs.map((src, idx) => ({ src: src, srcset: srcsets[idx] || '' }));
      if (Array.isArray(images) && images.length > 0) {
        const productId = input.getAttribute('data-product-id');
        const sectionId = input.getAttribute('data-section-id');
        const productUrl = input.getAttribute('data-product-url') || (mediaLink ? mediaLink.getAttribute('href') : '#');
        const primaryImgEl = productCard.querySelector('.product-card__image--primary');
        const imageClass = primaryImgEl ? primaryImgEl.getAttribute('class') : 'product-card__image product-card__image--primary';
        const sizesAttr = primaryImgEl ? primaryImgEl.getAttribute('sizes') : null;
        const altAttr = primaryImgEl ? primaryImgEl.getAttribute('alt') : '';

        // Build dots markup
        let dotsHtml = '<li class="carousel__dots-wrapper">\n  <ul class="carousel__dots">';
        for (let i = 1; i <= images.length; i++) {
          const slideId = `carousel__slide${productId}-${sectionId}-${i}`;
          dotsHtml += `\n    <li style="padding-inline-start: 0;">\n      <button class="carousel__dot" aria-label="Go to slide ${i}" data-slide-id="${slideId}"></button>\n    </li>`;
        }
        dotsHtml += '\n  </ul>\n</li>';

        // Build slides markup
        let slidesHtml = '';
        for (let i = 1; i <= images.length; i++) {
          const slideId = `carousel__slide${productId}-${sectionId}-${i}`;
          const prevId = `carousel__slide${productId}-${sectionId}-${i - 1}`;
          const nextId = `carousel__slide${productId}-${sectionId}-${i + 1}`;
          const img = images[i - 1];
          const prevDataIdx = i === 2 ? 'first' : '';
          const isSecondToLast = i === images.length - 1;
          const nextDataIdx = isSecondToLast ? 'last' : '';
          const slideIndexTag = i === 1 ? 'first' : (i === images.length ? 'last' : '');
          slidesHtml += `\n<li id="${slideId}" tabindex="0" class="carousel__slide"${slideIndexTag ? ` data-image-index="${slideIndexTag}"` : ''}>\n  <a href="${productUrl}" tabindex="0" aria-label="${altAttr ? altAttr.replace(/"/g, '&quot;') : ''}">\n    <img src="${img.src}" srcset="${img.srcset}"${sizesAttr ? ` sizes="${sizesAttr.replace(/"/g, '&quot;')}"` : ''} class="${imageClass}" alt="${altAttr ? altAttr.replace(/"/g, '&quot;') : ''}" loading="lazy">\n  </a>\n  <div class="carousel__snapper"></div>\n  <button class="carousel__control carousel__controls_prev" data-slide-id="${prevId}" data-image-index="${prevDataIdx}" aria-label="Previous image"></button>\n  <button class="carousel__control carousel__controls_next" data-slide-id="${nextId}" data-image-index="${nextDataIdx}" aria-label="Next image"></button>\n</li>`;
        }

        // Use temp slide approach for consistency (simpler version for clicks)
        const firstSlide = carouselViewport.querySelector('.carousel__slide');
        let tempSlide = null;
        
        if (firstSlide) {
          tempSlide = firstSlide;
          tempSlide.classList.add('carousel__temp');
        }
        
        // Remove non-temp children, preserving the temp slide
        Array.from(carouselViewport.children).forEach((child) => {
          if (!child.classList.contains('carousel__temp')) {
            carouselViewport.removeChild(child);
          }
        });
        
        // Append dots and slides
        const _wrapper = document.createElement('div');
        _wrapper.innerHTML = `${dotsHtml}\n${slidesHtml}`;
        while (_wrapper.firstChild) {
          carouselViewport.appendChild(_wrapper.firstChild);
        }
        
        // Remove temp slide immediately for clicks (no smooth transition needed)
        if (tempSlide) {
          tempSlide.remove();
        }

        // Force immediate scroll reset to first slide
        carouselViewport.scrollLeft = 0;
        
        // Reset active dot
        const firstDot = carouselViewport.querySelector('.carousel__dot');
        if (firstDot) firstDot.classList.add('active');
        
        // Additional scroll resets to ensure proper positioning
        requestAnimationFrame(() => {
          carouselViewport.scrollLeft = 0;
        });

        // Reset wrapper classes
        carouselWrapper.classList.remove('hidden-next');
        if (!carouselWrapper.classList.contains('hidden-prev')) {
          carouselWrapper.classList.add('hidden-prev');
        }
      }
    }
  } catch (err) {
    console.error('[Robot Swatches] Failed to rebuild carousel', err);
  }

  // --- PRICE UPDATE LOGIC ---
  // Find the price-list element in the product card
  const priceList = productCard.querySelector('.price-list');
  const quickBuyModal = productCard.querySelector('.quick-buy-modal');
  const productHandle = input.getAttribute('data-product-handle');
  console.log('the price list', priceList);
  if (priceList) {
    
    // Read price and compare-at-price from swatch
    let price = input.getAttribute('data-price');
    let compareAt = input.getAttribute('data-compare-at-price');
    console.log('productHandle', productHandle);

    // Build markup
    let priceHtml = '';
    priceHtml += `<sale-price class="${compareAt ? 'text-on-sale' : ''} h6">`;
    priceHtml += `<span class="sr-only">Sale price</span>`;
    priceHtml += price;
    priceHtml += `</sale-price>`;
    if (compareAt) {
      priceHtml += `<compare-at-price class="line-through">`;
      priceHtml += `<span class="sr-only">Regular price</span>`;
      priceHtml += compareAt;
      priceHtml += `</compare-at-price>`;
    }
    priceList.innerHTML = priceHtml;
  }
  if (quickBuyModal && productHandle) {
    console.log('');
    quickBuyModal.setAttribute('handle', productHandle);
  }
});

// Preview image and href on hover/focus (event delegation)
document.addEventListener('mouseenter', function(e) {
  if (!(e.target instanceof Element)) return;
  const label = e.target.closest('label.ProductCard--ColorSwatch');
  if (!label) return;
  const input = label.querySelector('input.product-card-robot-swatch-input');
  if (!input) return;
  const fieldset = label.closest('.ProductCard--ColorSwatchesFieldset');
  if (!fieldset) return;
  const productCard = fieldset.closest('.product-card');
  if (!productCard) return;

  // Handle ProductCard--ColorSwatch--Active class management
  const swatchesWrapper = fieldset.closest('.ProductCard--ColorSwatchesFieldsetWrapper');
  if (swatchesWrapper) {
    // Only proceed if the hovered swatch doesn't already have the active class
    if (!label.classList.contains('ProductCard--ColorSwatch--Active')) {
      // Remove active class from all ProductCard--ColorSwatch elements in this wrapper
      const allSwatches = swatchesWrapper.querySelectorAll('.ProductCard--ColorSwatch');
      allSwatches.forEach(swatch => swatch.classList.remove('ProductCard--ColorSwatch--Active'));
      // Add active class to the hovered swatch
      label.classList.add('ProductCard--ColorSwatch--Active');
    }
  }
  
  // Check which swatch/product is currently being viewed
  const mainImage = productCard.querySelector('.product-card__image--primary');
  const currentMainSrc = mainImage ? mainImage.getAttribute('src') : null;
  
  // Find which swatch matches the current main image (use product handle instead of exact src)
  let currentlyViewingSwatch = null;
  const allSwatches = fieldset.querySelectorAll('.product-card-robot-swatch-input');
  allSwatches.forEach((swatch, index) => {
    const swatchHandle = swatch.getAttribute('data-product-handle');
    // Check if current image URL contains this swatch's product handle
    if (currentMainSrc && swatchHandle && currentMainSrc.includes(swatchHandle)) {
      currentlyViewingSwatch = {
        input: swatch,
        handle: swatchHandle,
        index: index + 1,
        id: swatch.id
      };
    }
  });
  
  const hoverSwatchHandle = input.getAttribute('data-product-handle');
  const isDifferentProduct = currentlyViewingSwatch && currentlyViewingSwatch.handle !== hoverSwatchHandle;
  
  console.log('[Hover] Currently viewing swatch:', currentlyViewingSwatch ? `${currentlyViewingSwatch.handle} (index: ${currentlyViewingSwatch.index})` : 'unknown');
  console.log('[Hover] Hovering on swatch:', hoverSwatchHandle);
  console.log('[Hover] Is different product:', isDifferentProduct);
  
  // Don't do anything if hovering on the already checked swatch (current product)
  if (input.checked && currentlyViewingSwatch.index !== 1) {
    console.log('im here', currentlyViewingSwatch.index);
    console.log('[Hover] Skipping because input is checked:', input.id);
    return;
  }
  console.log('[Hover] Processing hover for unchecked input:', input.id);
  
  const secondaryImage = productCard.querySelector('.product-card__image--secondary');
  const mediaLink = productCard.querySelector('a.product-card__media');
  if (!mainImage) return;
  const newSrc = input.getAttribute('data-src');
  const newSrcset = input.getAttribute('data-srcset');
  if (newSrc) mainImage.setAttribute('src', newSrc);
  if (newSrcset) mainImage.setAttribute('srcset', newSrcset);
  if (secondaryImage) {
    const newSecondarySrc = input.getAttribute('data-secondary-src');
    const newSecondarySrcset = input.getAttribute('data-secondary-srcset');
    if (newSecondarySrc) secondaryImage.setAttribute('src', newSecondarySrc);
    if (newSecondarySrcset) secondaryImage.setAttribute('srcset', newSecondarySrcset);
  }
  if (mediaLink) {
    const newProductUrl = input.getAttribute('data-product-url');
    if (newProductUrl) mediaLink.setAttribute('href', newProductUrl);
  }

  // Update quick add variants for the selected product (hover)
  updateQuickAddVariants(productCard, input);

  // Only rebuild if the pointer stays relatively still within this swatch
  const SWATCH_STILL_MS = 20;
  const MOVE_THRESHOLD = 6; // px

  // cleanup any prior hover tracking on this label
  if (label._robotHoverCleanup) {
    label._robotHoverCleanup();
  }

  let lastX = (e.clientX || 0);
  let lastY = (e.clientY || 0);
  let moved = false;
  let timerId = null;

  const alreadyRebuiltForThisInput = () => fieldset._lastHoverRebuiltId === input.id;

  const schedule = () => {
    clearTimeout(timerId);
    moved = false;
    timerId = setTimeout(() => {
      // Don't rebuild if hovering on the already checked swatch (current product)
      if (input.checked) {
        return;
      }
      if (!moved && !alreadyRebuiltForThisInput()) {
        rebuildCarouselFromInput(productCard, input, mediaLink);
        fieldset._lastHoverRebuiltId = input.id;
      }
    }, SWATCH_STILL_MS);
  };

  const onMove = (ev) => {
    const x = ev.clientX || lastX;
    const y = ev.clientY || lastY;
    if (Math.abs(x - lastX) > MOVE_THRESHOLD || Math.abs(y - lastY) > MOVE_THRESHOLD) {
      moved = true;
      lastX = x;
      lastY = y;
      schedule();
    }
  };

  const onLeave = () => {
    clearTimeout(timerId);
    label.removeEventListener('mousemove', onMove);
    label.removeEventListener('mouseleave', onLeave);
    label._robotHoverCleanup = null;
  };

  label.addEventListener('mousemove', onMove, { passive: true });
  label.addEventListener('mouseleave', onLeave, { passive: true });
  label._robotHoverCleanup = onLeave;
  schedule();


  // --- PRICE UPDATE LOGIC ---
  // Find the price-list element in the product card
  const priceList = productCard.querySelector('.price-list');
  const quickBuyModal = productCard.querySelector('.quick-buy-modal');
  const productHandle = input.getAttribute('data-product-handle');
  console.log('the price list', priceList);
  if (priceList) {
    
    // Read price and compare-at-price from swatch
    let price = input.getAttribute('data-price');
    let compareAt = input.getAttribute('data-compare-at-price');
    console.log('productHandle', productHandle);

    // Build markup
    let priceHtml = '';
    priceHtml += `<sale-price class="${compareAt ? 'text-on-sale' : ''} h6">`;
    priceHtml += `<span class="sr-only">Sale price</span>`;
    priceHtml += price;
    priceHtml += `</sale-price>`;
    if (compareAt) {
      priceHtml += `<compare-at-price class="line-through">`;
      priceHtml += `<span class="sr-only">Regular price</span>`;
      priceHtml += compareAt;
      priceHtml += `</compare-at-price>`;
    }
    priceList.innerHTML = priceHtml;
  }
  if (quickBuyModal && productHandle) {
    console.log('');
    quickBuyModal.setAttribute('handle', productHandle);
  }
}, true);

document.addEventListener('focusin', function(e) {
  if (!(e.target instanceof Element)) return;
  const input = e.target;
  if (!input.classList.contains('product-card-robot-swatch-input')) return;
  const fieldset = input.closest('.ProductCard--ColorSwatchesFieldset');
  if (!fieldset) return;
  const productCard = fieldset.closest('.product-card');
  if (!productCard) return;
  
  // Don't do anything if focusing on the already checked swatch (current product)
  if (input.checked) {
    return;
  }
  
  const mainImage = productCard.querySelector('.product-card__image--primary');
  const secondaryImage = productCard.querySelector('.product-card__image--secondary');
  const mediaLink = productCard.querySelector('a.product-card__media');
  if (!mainImage) return;
  const newSrc = input.getAttribute('data-src');
  const newSrcset = input.getAttribute('data-srcset');
  if (newSrc) mainImage.setAttribute('src', newSrc);
  if (newSrcset) mainImage.setAttribute('srcset', newSrcset);
  if (secondaryImage) {
    const newSecondarySrc = input.getAttribute('data-secondary-src');
    const newSecondarySrcset = input.getAttribute('data-secondary-srcset');
    if (newSecondarySrc) secondaryImage.setAttribute('src', newSecondarySrc);
    if (newSecondarySrcset) secondaryImage.setAttribute('srcset', newSecondarySrcset);
  }
  if (mediaLink) {
    const newProductUrl = input.getAttribute('data-product-url');
    if (newProductUrl) mediaLink.setAttribute('href', newProductUrl);
  }
  
  // Rebuild carousel for focus preview
  rebuildCarouselFromInput(productCard, input, mediaLink);
  
  // Update quick add variants for the focused product
  updateQuickAddVariants(productCard, input);
});
// Revert to checked swatch or first swatch on mouseleave/blur (event delegation)
function revertToOriginal(fieldset, options) {
  options = options || {};
  const forceFirst = !!options.forceFirst;
  const productCard = fieldset.closest('.product-card');
  if (!productCard) return;
  const mainImage = productCard.querySelector('.product-card__image--primary');
  const secondaryImage = productCard.querySelector('.product-card__image--secondary');
  const mediaLink = productCard.querySelector('a.product-card__media');
  if (!mainImage) return;

  // Handle ProductCard--ColorSwatch--Active class management on mouseleave
  const swatchesWrapper = fieldset.closest('.ProductCard--ColorSwatchesFieldsetWrapper');
  if (swatchesWrapper) {
    const firstSwatch = swatchesWrapper.querySelector('.ProductCard--ColorSwatch');
    if (firstSwatch && !firstSwatch.classList.contains('ProductCard--ColorSwatch--Active')) {
      // Remove active class from all swatches in the wrapper
      const allSwatches = swatchesWrapper.querySelectorAll('.ProductCard--ColorSwatch');
      allSwatches.forEach(swatch => swatch.classList.remove('ProductCard--ColorSwatch--Active'));
      // Add active class to the first swatch
      firstSwatch.classList.add('ProductCard--ColorSwatch--Active');
    }
  }

  // Choose target swatch: on mobile leave we may force reverting to the first swatch
  let targetInput = null;
  if (forceFirst) {
    // Ensure first swatch becomes the checked one to keep state consistent
    const allInputs = fieldset.querySelectorAll('.product-card-robot-swatch-input');
    allInputs.forEach(function(i, idx) { i.checked = (idx === 0); });
    targetInput = allInputs[0] || null;
  } else {
    targetInput = fieldset.querySelector('.product-card-robot-swatch-input:checked') ||
      fieldset.querySelector('.product-card-robot-swatch-input');
  }

  if (targetInput) {
    // Check if we're actually changing to a different product
    const currentProductHandle = targetInput.getAttribute('data-product-handle');
    const currentMainSrc = mainImage.getAttribute('src');
    const targetSrc = targetInput.getAttribute('data-src');
    const isActuallyChanging = currentMainSrc !== targetSrc;
    
    console.log('[Revert] Target input:', targetInput.id, 'checked:', targetInput.checked);
    console.log('[Revert] Current src:', currentMainSrc);
    console.log('[Revert] Target src:', targetSrc);
    console.log('[Revert] Is actually changing:', isActuallyChanging);
    
    // Use the same logic as our swatch interactions
    // Update main image
    const newSrc = targetInput.getAttribute('data-src');
    const newSrcset = targetInput.getAttribute('data-srcset');
    if (newSrc) mainImage.setAttribute('src', newSrc);
    if (newSrcset) mainImage.setAttribute('srcset', newSrcset);

    // Update secondary image if present
    if (secondaryImage) {
      const newSecondarySrc = targetInput.getAttribute('data-secondary-src');
      const newSecondarySrcset = targetInput.getAttribute('data-secondary-srcset');
      if (newSecondarySrc) secondaryImage.setAttribute('src', newSecondarySrc);
      if (newSecondarySrcset) secondaryImage.setAttribute('srcset', newSecondarySrcset);
    }

    // Update product-card__media href
    if (mediaLink) {
      const newProductUrl = targetInput.getAttribute('data-product-url');
      if (newProductUrl) mediaLink.setAttribute('href', newProductUrl);
    }

    // Only rebuild carousel if we're actually changing to a different product/swatch
    // AND we're not reverting to a checked swatch (which means we're already on the "correct" product)
    if (isActuallyChanging && !targetInput.checked) {
      console.log('[Revert] Rebuilding carousel because changing to unchecked swatch');
      rebuildCarouselFromInput(productCard, targetInput, mediaLink);
    } else if (targetInput.checked) {
      console.log('[Revert] Skipping rebuild because target is checked (already on correct product)');
      // But still reset carousel scroll position to first slide if user had scrolled away from first slide
      const carouselViewport = productCard.querySelector('.carousel__viewport');
      console.log('carouselViewport', carouselViewport);
      if (carouselViewport && carouselViewport.scrollLeft > 10) { // Small threshold to account for rounding
        console.log('[Revert] User is not on first slide, resetting carousel scroll to first slide');
        carouselViewport.scrollLeft = 0;
        // Update active dot to first
        const carouselWrapper = productCard.querySelector('.carousel');
        if (carouselWrapper) {
          const firstDot = carouselWrapper.querySelector('.carousel__dot');
          const allDots = carouselWrapper.querySelectorAll('.carousel__dot');
          allDots.forEach(dot => dot.classList.remove('active'));
          if (firstDot) firstDot.classList.add('active');
          // Update hidden-prev/hidden-next classes
          carouselWrapper.classList.remove('hidden-next');
          carouselWrapper.classList.add('hidden-prev');
        }
      } else {
        console.log('[Revert] User is already on first slide, no scroll reset needed');
      }
    } else {
      console.log('[Revert] Skipping rebuild because not actually changing');
    }
    
    // Update quick add variants to match the target swatch
    updateQuickAddVariants(productCard, targetInput);

    // Update price if we have price data
    const priceList = productCard.querySelector('.price-list');
    const quickBuyModal = productCard.querySelector('.quick-buy-modal');
    const productHandle = targetInput.getAttribute('data-product-handle');
    
    if (priceList) {
      const price = targetInput.getAttribute('data-price');
      const compareAt = targetInput.getAttribute('data-compare-at-price');
      
      if (price) {
        let priceHtml = '';
        priceHtml += `<sale-price class="${compareAt ? 'text-on-sale' : ''} h6">`;
        priceHtml += `<span class="sr-only">Sale price</span>`;
        priceHtml += price;
        priceHtml += `</sale-price>`;
        if (compareAt) {
          priceHtml += `<compare-at-price class="line-through">`;
          priceHtml += `<span class="sr-only">Regular price</span>`;
          priceHtml += compareAt;
          priceHtml += `</compare-at-price>`;
        }
        priceList.innerHTML = priceHtml;
      }
    }
    
    if (quickBuyModal && productHandle) {
      quickBuyModal.setAttribute('handle', productHandle);
    }
  } else {
    // Fallback to stored original values if no swatches found
    if (fieldset._originalSrc) mainImage.setAttribute('src', fieldset._originalSrc);
    if (fieldset._originalSrcset) mainImage.setAttribute('srcset', fieldset._originalSrcset);
    if (secondaryImage) {
      if (fieldset._originalSecondarySrc) secondaryImage.setAttribute('src', fieldset._originalSecondarySrc);
      if (fieldset._originalSecondarySrcset) secondaryImage.setAttribute('srcset', fieldset._originalSecondarySrcset);
    }
    if (mediaLink && fieldset._originalMediaHref) {
      mediaLink.setAttribute('href', fieldset._originalMediaHref);
    }
  }
}

document.addEventListener('mouseout', function(e) {
  if (!(e.target instanceof Element)) return;
  // Only handle if leaving a .product-card
  const productCard = e.target.closest('.product-card');
  if (!productCard) return;
  // If moving to a descendant of the same product card, do nothing
  if (e.relatedTarget instanceof Element && productCard.contains(e.relatedTarget)) return;
  // Find the swatch fieldset inside this product card
  const fieldset = productCard.querySelector('.ProductCard--ColorSwatchesFieldset');
  if (!fieldset) return;
  revertToOriginal(fieldset);
}, true);

document.addEventListener('focusout', function(e) {
  if (!(e.target instanceof Element)) return;
  const input = e.target;
  if (!input.classList.contains('product-card-robot-swatch-input')) return;
  const fieldset = input.closest('.ProductCard--ColorSwatchesFieldset');
  if (!fieldset) return;
  revertToOriginal(fieldset);
});


// Click to toggle swatch scroller via product-card__robot-swatches-trigger
(function() {
  let activeWrapper = null;
  let activeCard = null;
  let mobileRevertEnabled = false;
  let scrollRevertScheduled = false;

  function isMobileLike() {
    try {
      return (
        (typeof window !== 'undefined' && 'ontouchstart' in window) ||
        (typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints)) ||
        (typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(pointer: coarse)').matches)
      );
    } catch (_) {
      return false;
    }
  }

  function revertActiveCardIfAny() {
    try {
      if (!activeCard) return;
      const fieldset = activeCard.querySelector('.ProductCard--ColorSwatchesFieldset');
      if (fieldset) revertToOriginal(fieldset, { forceFirst: !!mobileRevertEnabled });
    } catch (_) {}
  }

  function hideAndCleanup() {
    try {
      if (activeWrapper) {
        activeWrapper.style.display = 'none';
      }
    } catch (_) {}
    activeWrapper = null;
    activeCard = null;
    mobileRevertEnabled = false;
    scrollRevertScheduled = false;
  }

  function handleMobileLeave() {
    if (!activeWrapper || !mobileRevertEnabled) return;
    revertActiveCardIfAny();
    hideAndCleanup();
  }

  function hideAllSwatchWrappers() {
    document.querySelectorAll('.ProductCard--ColorSwatchesFieldsetWrapper').forEach(function(wrapper) {
      wrapper.style.display = 'none';
    });
    // If we had an active mobile interaction, also revert that card
    if (mobileRevertEnabled) {
      revertActiveCardIfAny();
    }
    activeWrapper = null;
    activeCard = null;
    mobileRevertEnabled = false;
    scrollRevertScheduled = false;
  }

  document.addEventListener('click', function(e) {
    if (!(e.target instanceof Element)) return;
    const trigger = e.target.closest('.product-card__robot-swatches-trigger');
    if (!trigger) return;

    const card = trigger.closest('.product-card');
    if (!card) return;
    const wrapper = card.querySelector('.ProductCard--ColorSwatchesFieldsetWrapper');
    if (!wrapper) return;

    const isVisible = (wrapper.style.display && wrapper.style.display !== 'none') || window.getComputedStyle(wrapper).display !== 'none';

    // Toggle behavior: hide others, then show if it was not visible
    hideAllSwatchWrappers();
    if (!isVisible) {
      wrapper.style.display = 'block';
      activeWrapper = wrapper;
      activeCard = card;
      mobileRevertEnabled = isMobileLike();
      // Ensure scroller starts at beginning
      try { wrapper.scrollLeft = 0; } catch (_) {}
    }
  });

  // Hide when clicking outside the wrapper or the trigger
  document.addEventListener('click', function(e) {
    if (!(e.target instanceof Element)) return;
    if (!activeWrapper) return;
    if (e.target.closest('.ProductCard--ColorSwatchesFieldsetWrapper')) return;
    if (e.target.closest('.product-card__robot-swatches-trigger')) return;
    // Only revert on mobile when actually leaving the active card
    const clickedInsideActiveCard = activeCard && activeCard.contains(e.target);
    if (mobileRevertEnabled && !clickedInsideActiveCard) {
      revertActiveCardIfAny();
    }
    hideAndCleanup();
  }, true);

  // Mobile: tap outside the active card should revert and hide
  document.addEventListener('touchstart', function(e) {
    if (!(e.target instanceof Element)) return;
    if (!activeWrapper || !mobileRevertEnabled) return;
    if (!activeCard || activeCard.contains(e.target)) return;
    handleMobileLeave();
  }, true);

  // Mobile: pointerdown with touch outside the active card should revert and hide
  document.addEventListener('pointerdown', function(e) {
    if (!(e.target instanceof Element)) return;
    if (!activeWrapper || !mobileRevertEnabled) return;
    if (e.pointerType !== 'touch') return;
    if (!activeCard || activeCard.contains(e.target)) return;
    handleMobileLeave();
  }, true);

  // Mobile: any scroll while the swatch scroller is open implies leaving the card
  window.addEventListener('scroll', function() {
    if (!activeWrapper || !mobileRevertEnabled) return;
    if (scrollRevertScheduled) return;
    scrollRevertScheduled = true;
    // Defer to next tick so we don't fight with scrolling
    setTimeout(function() {
      scrollRevertScheduled = false;
      handleMobileLeave();
    }, 0);
  }, { passive: true });
})();